"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const with_1 = require("../node/with");
class TwingTokenParserWith extends token_parser_1.TwingTokenParser {
    parse(token) {
        let stream = this.parser.getStream();
        let variables = null;
        let only = false;
        if (!stream.test(token_1.TwingToken.BLOCK_END_TYPE)) {
            variables = this.parser.getExpressionParser().parseExpression();
            only = stream.nextIf(token_1.TwingToken.NAME_TYPE, 'only') !== null;
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let body = this.parser.subparse([this, this.decideWithEnd], true);
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new with_1.TwingNodeWith(body, variables, only, token.getLine(), token.getColumn(), this.getTag());
    }
    decideWithEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endwith');
    }
    getTag() {
        return 'with';
    }
}
exports.TwingTokenParserWith = TwingTokenParserWith;
